import { render, staticRenderFns } from "./entrepreneurRejected.vue?vue&type=template&id=9c032008&scoped=true"
import script from "./entrepreneurRejected.vue?vue&type=script&lang=js"
export * from "./entrepreneurRejected.vue?vue&type=script&lang=js"
import style0 from "./entrepreneurRejected.vue?vue&type=style&index=0&id=9c032008&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c032008",
  null
  
)

export default component.exports